import { __awaiter } from 'tslib';

function detectAllowCryptographyApi() {
    return typeof window !== 'undefined' && typeof window.crypto !== 'undefined' && typeof window.crypto.subtle !== 'undefined';
}
function decryptAesGcm(input, key, iv) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!detectAllowCryptographyApi()) {
            return undefined;
        }
        try {
            const algorithm = {
                name: 'AES-GCM',
                iv
            };
            const cipherKey = yield window.crypto.subtle.importKey('raw', key, algorithm, false, ['decrypt']);
            return crypto.subtle.decrypt(algorithm, cipherKey, input);
        }
        catch (err) {
            return undefined;
        }
    });
}

export { decryptAesGcm };
//# sourceMappingURL=aesGcm.js.map
